// This is the loader for campaign modules
// Dynamically import campaign related module

const campaignModuleNestedRoutes: any = []
const files = require.context(
  '@/modules/campaign',
  true,
  /\/routes\/index.ts$/i
)

files.keys().forEach(key => {
  let keyname = key.match(/\.\/([0-9A-Za-z_]+)\/routes\/index\.ts/)![1]
  const nestedRoute = {
    path: keyname,
    props: true,
    component: () => import('./Layout.vue'),
    children: [files(key).default]
  }
  // console.log('Key Name:', keyname, nestedRoute)
  campaignModuleNestedRoutes.push(nestedRoute)
})
export default {
  path: '/campaign/',
  redirect: {
    name: 'Landing'
  },
  // component: () =>
  //   import(/* webpackChunkName: "campaign-layout" */ './Layout.vue'),
  children: campaignModuleNestedRoutes
}
